<template>
  <div class="min-h-screen bg-gray-50 px-4 py-6 pb-28" dir="rtl">
    <div class="max-w-3xl mx-auto">
      <div class="bg-white rounded-xl border border-gray-200 p-4">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <!-- Product Type -->
          <div>
            <label class="block text-sm text-gray-600 mb-1">نوع محصول</label>
            <select v-model.number="selected_product_types" class="w-full h-10 rounded-lg border border-gray-300 bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
              <option v-for="t in product_types" :key="t.Id" :value="t.Id">{{ t.ProductTypeTitle }}</option>
            </select>
          </div>

          <!-- Product Category -->
          <div>
            <label class="block text-sm text-gray-600 mb-1">دسته محصول</label>
            <select v-model.number="selected_product_cats" class="w-full h-10 rounded-lg border border-gray-300 bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
              <option v-for="c in product_cats" :key="c.Id" :value="c.Id">{{ c.CategoryTitle }}</option>
            </select>
          </div>

          <!-- Product Group -->
          <div>
            <label class="block text-sm text-gray-600 mb-1">گروه محصول</label>
            <select v-model.number="selected_product_groups" class="w-full h-10 rounded-lg border border-gray-300 bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
              <option v-for="g in product_groups" :key="g.Id" :value="g.Id">{{ g.CategoryGroupTitle }}</option>
            </select>
          </div>

          <!-- Product Brand -->
          <div>
            <label class="block text-sm text-gray-600 mb-1">برند محصول</label>
            <select v-model.number="selected_product_brands" class="w-full h-10 rounded-lg border border-gray-300 bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
              <option v-for="b in product_brands" :key="b.Id" :value="b.Id">{{ b.SubGroupTitle }}</option>
            </select>
          </div>

          <!-- Product Details (Multiple) -->
          <div class="sm:col-span-2">
            <label class="block text-sm text-gray-600 mb-1">خصوصیات محصول</label>
            <select multiple v-model="selected_product_details" class="w-full min-h-2.5rem rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
              <option v-for="d in product_details" :key="d.ItemId" :value="d.ItemId">{{ d.ItemTitle }}</option>
            </select>
            <div class="flex flex-wrap gap-2 mt-2">
              <span v-for="val in selected_product_details" :key="val" class="px-2 py-0.5 rounded-full bg-blue-50 text-blue-700 text-xs">{{ (product_details.find(x => x.ItemId == val) || {}).ItemTitle }}</span>
            </div>
          </div>

          <!-- Device Model Picker trigger -->
          <div class="sm:col-span-2">
            <button type="button" @click="dialog_model = true" class="w-full h-10 rounded-lg border border-gray-300 bg-white px-3 text-sm text-right hover:bg-gray-50">
              مدل دستگاه : {{ product_model_title }}
            </button>
          </div>

          <!-- Description -->
          <div class="sm:col-span-2">
            <label class="block text-sm text-gray-600 mb-1">توضیحات</label>
            <textarea v-model="description" rows="4" class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="توضیحات"></textarea>
          </div>

          <!-- Generated Product Name -->
          <div class="sm:col-span-2 text-gray-700 text-sm">
            {{ product_name }}
          </div>
        </div>
      </div>

      <!-- Submit Button -->
      <div class="mt-4">
        <button @click="insert_pre_product()" class="w-full h-11 rounded-lg bg-blue-600 text-white font-bold hover:bg-blue-700 transition">
          افزودن کالا
        </button>
      </div>
    </div>

    <!-- Modal: Device Model -->
    <div v-if="dialog_model" class="fixed inset-0 z-999 flex items-start sm:items-center justify-center bg-black bg-opacity-40">
      <div class="w-full h-full sm:h-auto sm:max-w-lg bg-white sm:rounded-2xl sm:shadow-xl overflow-hidden" dir="rtl">
        <div class="px-4 pt-4 pb-2 border-b border-gray-100 text-gray-900 font-bold">
          {{$t('deviceModel')}}
        </div>
        <div class="p-4 space-y-3">
          <treeselect
            :multiple="false"
            :load-options="load_models"
            :normalizer="normalizer_models"
            :async="true"
            :placeholder="$t('searchDeviceModel')"
            v-model="product_model_id"
          />

          <div class="text-xs text-gray-500">{{$t('selectedModel')}}</div>
          <div class="text-sm text-gray-900">{{ product_model_title }}</div>
        </div>
        <div class="px-4 py-3 border-t border-gray-100 flex items-center justify-end">
          <button @click="dialog_model = false" class="h-9 px-4 rounded-lg bg-blue-600 text-white text-sm font-bold">{{$t('ok')}}</button>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import Treeselect, {ASYNC_SEARCH} from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import axios from 'axios'
import Vue from 'vue'

import {bus} from '../../main'

const simulateAsyncOperation = fn => {
  setTimeout(fn, 200)
}
export default {
  props: [
    'passing_data'
  ],
  data() {
    return {
      dialog_model:false,
      description: '',
      product_types: [],
      product_cats: [],
      product_groups: [],
      product_brands: [],
      product_details: [],
      selected_product_types: 0,
      selected_product_cats: 0,
      selected_product_groups: 0,
      selected_product_brands: 0,
      selected_product_details: [],
      product_name: '',
      product_model_id: 0,
      product_model_title: "",
      normalizer_models (node) {
        return {
          id: node.Id,
          label: node.Title,
        }
      },
      search_entries: [],

    }
  },
  computed: {},
  components: {Treeselect},
  watch: {
    product_model_id () {
      for (var i = 0; i < this.search_entries.length; i++) {
        if (this.search_entries[i].Id == this.product_model_id) {
          this.product_model_title = this.search_entries[i].Title
        }
      }
    },
    selected_product_types: function () {
      this.get_product_cats()
      this.generate_product_name()
    },
    selected_product_cats: function () {
      this.get_product_groups()
      this.generate_product_name()
    },
    selected_product_groups: function () {
      this.get_product_brands()
      this.get_product_details()
      this.generate_product_name()
    },
    selected_product_brands: function () {
      this.generate_product_name()
    },
    selected_product_details: function () {
      this.generate_product_name()
    },
    product_model_title: function () {
      this.generate_product_name()
    },
  },
  mounted() {
    this.get_product_type()
  },

  methods: {
    load_models ({ action, searchQuery, callback }) {
      this.product_model_title = searchQuery
      var self = this
      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {
          let options

          var passing_data = JSON.parse(localStorage.getItem('request_data'))

          const send_data = {
            txt: searchQuery,
            sgid: this.selected_product_brands,
          }
          this.axios.post('/GetProductModels', send_data, {show_pros: false})
            .then(response => {
              self.search_entries = response.data.results
              options = response.data.results
              callback(null, options)
              // this.$router.push({ path: "/post-login", params: {} });
            }).catch(e => {
            this.errors.push(e)
          })

          //
          // axios.post('/api/admin/product_search-tags', {
          //   search: searchQuery,
          //
          // }).then(function (response) {
          //   options = response.data;
          //   callback(null, options);
          //   // localStorage.setItem("api_token", response.data.access_token);
          //   // self.$router.push({ path: 'notes' });
          // })
          //   .catch(function (error) {
          //     self.message = 'Incorrect E-mail or password';
          //     self.showMessage = true;
          //     console.log(error);
          //   });

          //  const options = this.get_keywords(searchQuery);
          // const options = [1, 2, 3, 4, 5].map(i => ({
          //     id: `${searchQuery}-${i}`,
          //     name: `${searchQuery}-${i}`,
          // }))
        })
      }
    },

    generate_product_name() {
      var self = this
      try {
        const group_name = this.product_groups.filter(x => x.Id == this.selected_product_groups)[0].CategoryGroupTitle || '';
        const brand_name = this.product_brands.filter(x => x.Id == this.selected_product_brands)[0].SubGroupTitle || '';
        this.product_name =
          ' ' + group_name
        this.selected_product_details.forEach(function (val) {
          self.product_name += " " + self.product_details.filter(x => x.ItemId == val)[0].ItemTitle
        })
        this.product_name += " " + brand_name
        this.product_name += " " + this.product_model_title
      } catch (e) {
        console.log(e)
      }

    },
    get_product_type() {
      var self = this
      const send_data = {}
      // this.axios.post('/Register' , send_data,{
      this.axios.post('/GetProductTypeList', send_data, {})
        .then(response => {
          if (response.data.error == 0) {
            self.product_types = response.data.Types
            self.selected_product_types = self.product_types[0].Id
          }
        }).catch(e => {
        this.errors.push(e)
      })
    },
    get_product_cats() {
      var self = this
      const send_data = {
        pTypeId: this.selected_product_types,
      }
      this.axios.post('/GetReqTypeCategoryByTypeId', send_data, {})
        .then(response => {
          if (response.data.error == 0) {
            self.product_cats = response.data.categories
            self.selected_product_cats = self.product_cats[0].Id

          }
        }).catch(e => {
        this.errors.push(e)
      })
    },
    get_product_groups() {
      var self = this
      const send_data = {
        catId: this.selected_product_cats,

      }
      this.axios.post('/GetReqCategoryGroupListRelByCatId', send_data, {})
        .then(response => {
          if (response.data.error == 0) {
            self.product_groups = response.data.groups
            self.selected_product_groups = self.product_groups[0].Id

          }
        }).catch(e => {
        this.errors.push(e)
      })
    },
    get_product_brands() {
      var self = this
      const send_data = {
        groupId: this.selected_product_groups,
      }
      // this.axios.post('/Register' , send_data,{
      this.axios.post('/GetReqCategorySubGroupListRelByGrpId', send_data, {})
        .then(response => {
          if (response.data.error == 0) {
            self.product_brands = response.data.subGroups
            self.selected_product_brands = self.product_brands[0].Id

          }
        }).catch(e => {
        this.errors.push(e)
      })
    },
    get_product_details() {
      var self = this
      const send_data = {
        grpId: this.selected_product_groups
      }
      // this.axios.post('/Register' , send_data,{
      this.axios.post('/GetProductGroupDetailsByKeyword', send_data, {})
        .then(response => {
          if (response.data.error == 0) {
            self.product_details = response.data.Types
            self.selected_product_details = []
          }
        }).catch(e => {
        this.errors.push(e)
      })
    },
    insert_pre_product() {

      var self = this
      let details = []
      this.selected_product_details.forEach(function (val){
        const det = self.product_details.filter(x => x.ItemId == val)[0]
details.push(det);
      })
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId

      const json ={
        UserId:user_id,
        ProductTypeId:this.selected_product_types,
        CategoryId:this.selected_product_cats,
        GroupIdd:this.selected_product_groups,
        SubGroupId:this.selected_product_brands,
        ProductUnitId:1,
        ProductName:this.product_name,
        ModelId:this.product_model_id,
        ModelTitle:this.product_model_title,
        Description:this.description,
        GrpDetailValue:JSON.stringify(details)
      }

      // this.axios.post('/Register' , send_data,{
      this.axios.post('/AddPreProduct', json, {})
        .then(response => {
          bus.$emit('show_toast', [1500, response.data.msg])

          if (response.data.error == 0) {
            self.$router.go(-1)
          }
        }).catch(e => {
        this.errors.push(e)
      })
    },
  }
}
</script>
